import React from 'react';

import './SpecialProductList.sass';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { analyticsClearEcommerce, analyticsSelectLimitedItem } from '../../middlewares/analytics/actions';

import Button from '../button/Button';
import CountdownTimer from '../countdownTimer/CountdownTimer';
import ChannelImage from '../../containers/channelUtils/ChannelImage';
import ChannelLink from '../../containers/channelUtils/ChannelLink';
import Pricing from '../pricing/Pricing';

@connect()
export default class SpecialProductList extends React.PureComponent {
  onSpecialProductSelect = (product, index) => {
    const { dispatch, taxon } = this.props;

    dispatch(analyticsClearEcommerce());
    dispatch(analyticsSelectLimitedItem(taxon, product, index));
  };

  render() {
    const { products } = this.props;

    return (
      <div className="row">
        {products.map((product, index) => (
          <div className="special-product" key={product.code}>
            <ChannelLink to={`/service/${product.slug}`} onClick={() => this.onSpecialProductSelect(product, index)}>
              <div className="special-product__box">
                <div className="special-product__bg">
                  <ChannelImage
                    loading="lazy"
                    alt={product.name}
                    src={product.images.find((it) => ['base', 'main'].includes(it.type))}
                  />
                </div>
                <div className="special-product__content">
                  <CountdownTimer until={product.expiresAt} />

                  <div className="special-product__info">
                    <div className="special-product__title">{product.name}</div>

                    <div className="special-product__bottom">
                      <div className="special-product__price">
                        {product.isConfigurable && <div className="special-product__starts">Starts at</div>}

                        <div className="special-product__value">
                          <Pricing value={product.price} originalValue={product.originalPrice} />
                        </div>
                      </div>

                      <Button filled>
                        <FormattedMessage id="section.products.details-desktop" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </ChannelLink>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/specialProductList/SpecialProductList.js